module.exports = __webpack_public_path__ + "r-v3/img/ico_check.835d01d3.svg";